import React, { useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { isNumber } from 'util'

/* eslint-disable react/destructuring-assignment */
/**
 * NOTE
 * all the components can have following props
 *  + timeout [default: 300]
 */

import { timeout, pageTimeout } from './constants'
import './animations.scss'

export const SlideInLeft = (props) => {
  const { children, className = '', toggle } = props

  return (
    <div className={`animation slide-in left ${className} ${toggle ? 'animate' : ''}`}>
      {children}
    </div>
  )
}

/**
 * This is more amimed towards page-load
 * This component fades in on component mount
 * and fade out on component unmount
 * @param {object} props
 */
export const FadeIn = (props) => (
  <CSSTransition
    in={props.toggle || true}
    appear
    timeout={props.timeout || pageTimeout}
    classNames="fadeIn"
  >
    <div className={`animation ${props.className || ''}`}>{props.children}</div>
  </CSSTransition>
)

export const Fade = (props) => {
  const { className = '', children, toggle, disabled } = props

  const _in = !!props.in
  const [_toggle, setToggle] = useState(toggle ? 'toggle' : '')

  if (disabled) return children

  if (_in) {
    setTimeout(() => setToggle('toggle'), isNumber(props.in) ? props.in : 200)
  }
  return <div className={`animation fade ${_toggle} ${className}`}>{children}</div>
}

/**
 * This component collapses in and out on toggle
 * (height and fading is effected)
 * @param {object} props
 */
export const Collapse = (props) => (
  <CSSTransition in={props.toggle} timeout={timeout} classNames="collapse">
    <div className="animation">{props.children}</div>
  </CSSTransition>
)

const CardFlipAnimation = (props) => {
  const { toggle, children, className = '', ...restProps } = props
  const flipped = toggle ? '' : 'flip'
  return (
    <div className={`card-flip-container horizontal ${className}`} {...restProps}>
      <div className={`card-flip-inner ${flipped}`}>{children}</div>
    </div>
  )
}

CardFlipAnimation.Vertical = (props) => {
  const { toggle, children, className = '', ...restProps } = props
  const flipped = toggle ? '' : 'flip'
  return (
    <div className={`card-flip-container vertical ${className}`} {...restProps}>
      <div className={`card-flip-inner ${flipped}`}>{children}</div>
    </div>
  )
}

CardFlipAnimation.Front = (props) => {
  const { children, className = '', ...restProps } = props
  return (
    <div className={`front ${className}`} {...restProps}>
      {props.children}
    </div>
  )
}

CardFlipAnimation.Back = (props) => {
  const { children, className = '', ...restProps } = props
  return (
    <div className={`back ${className}`} {...restProps}>
      {props.children}
    </div>
  )
}
/* eslint-enable react/destructuring-assignment */

export const CardFlip = CardFlipAnimation
